import React, {useState} from "react";
import styled from "styled-components";
import bgImg from "../images/bg-img.jpg";
import logo from "../images/logo-white.png";
import NavBar from "./NavBar";
import Hamburger from "./Hamburger";
import { useWindowWidth} from '@react-hook/window-size'
import BackgroundSlider from 'react-background-slider'
import bg1 from "../images/background1.jpg"
import bg2 from "../images/background2.jpg"
import bg3 from "../images/background3.jpg"
import bg4 from "../images/background4.jpg"

const Home = styled.div`
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
`;

const Image = styled.div`
  width: 100vw;
  height: 100vh;
  background-image: url(${bgImg});
  background-size: cover;
  background-position: center;
`;
const LogoBg = styled.div`
  position: absolute;
  background-color: #982822;
  left: 50%;
  transform: translate(-50%, 0%);
  z-index: 2;
  > img {
    width: 320px;
    margin: 1rem 1rem 0 1rem;
    @media (max-width: 760px) {
      width: 200px;
    }
  }
`;


function HomeScreen() {
    const [open, setOpen] = useState(true);
    const screenWidth = useWindowWidth();
  
  return (
    <Home>
      <BackgroundSlider
        images={[bg1, bg4, bg3, bg2]}
        duration={5} transition={1.3} />
      {screenWidth > 1000 ? <NavBar /> : <Hamburger />}
    </Home>
  );
}

export default HomeScreen;
